import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import React from "react";
import strings from "../../config/localization";

interface Props {
  onClickHandler?: () => void;
  label?: string;
  disabled?: boolean;
}

export default function AddButton({
  onClickHandler = () => {},
  label = strings.add,
  disabled = false,
}: Props) {
  return (
    <Button
      disabled={disabled}
      variant="outlined"
      size="medium"
      startIcon={<AddCircleIcon />}
      onClick={onClickHandler}
    >
      {label}
    </Button>
  );
}
